import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

export default function Privacy() {
  const { t, language, setLanguage } = useLanguage();
  
  return (
    <div className="min-h-screen bg-[#020617] text-slate-300 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <Link 
            to="/login" 
            className="inline-flex items-center text-slate-400 hover:text-[#D4AF37] transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t('login')}
          </Link>
          
          <Select value={language} onValueChange={setLanguage}>
            <SelectTrigger className="w-[140px] border-slate-700 bg-slate-800/50">
              <Globe className="h-4 w-4 mr-2" />
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="en">{t('english')}</SelectItem>
              <SelectItem value="pt">{t('portuguese')}</SelectItem>
              <SelectItem value="fr">{t('french')}</SelectItem>
              <SelectItem value="es">{t('spanish')}</SelectItem>
              <SelectItem value="el">{t('greek')}</SelectItem>
              <SelectItem value="ru">{t('russian')}</SelectItem>
              <SelectItem value="it">{t('italian')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="glass-card p-8">
          <h1 className="font-heading text-3xl font-bold text-[#D4AF37] mb-6">{t('privacyPolicyTitle')}</h1>
          <p className="text-slate-400 text-sm mb-8">{t('privacyLastUpdated')}: December 2025</p>
          
          <div className="space-y-6 text-slate-300 leading-relaxed">
            <p>{t('privacyIntro')}</p>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">1. {t('privacyDataCollection')}</h2>
              <p>{t('privacyDataCollectionText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">2. {t('privacyDataUse')}</h2>
              <p>{t('privacyDataUseText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">3. {t('privacyDataSharing')}</h2>
              <p>{t('privacyDataSharingText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">4. {t('privacyDataSecurity')}</h2>
              <p>{t('privacyDataSecurityText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">5. {t('privacyUserRights')}</h2>
              <p>{t('privacyUserRightsText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">6. {t('privacyCookies')}</h2>
              <p>{t('privacyCookiesText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">7. {t('privacyChanges')}</h2>
              <p>{t('privacyChangesText')}</p>
            </section>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">8. {t('privacyContact')}</h2>
              <p>{t('privacyContactText')}</p>
            </section>
          </div>
        </div>
        
        <p className="text-center mt-8 text-slate-500 text-sm">
          {t('termsOfService')}: <Link to="/terms" className="text-[#D4AF37] hover:underline">{t('terms')}</Link>
        </p>
      </div>
    </div>
  );
}
